import {Pipe, type PipeTransform} from '@angular/core';

@Pipe({
  name: 'timeLeft',
})
export class TimeLeftPipe implements PipeTransform {
  transform(ms: number): string {
    if (ms < 0) ms = 0;
    const oneSecond = 1000;
    const oneMinute = oneSecond * 60;
    const oneHour = oneMinute * 60;
    const oneDay = oneHour * 24;
    const h = Math.floor((ms % oneDay) / oneHour);
    const m = Math.floor((ms % oneHour) / oneMinute);
    return `${h} hours and ${m} minutes`; // add function
  }

  private _pad(n: number): string {
    return n.toLocaleString('en', {minimumIntegerDigits: 2});
  }
}
